import * as React from 'react';
import { EPageTypes, EPlatformTypes } from '@cian/frontend-dynamic-calltracking-component';
import { SimpleCall } from '@cian/frontend-newbuilding-call-component';
import { useSelector } from 'react-redux';

import { trackShowPhone } from './tracking';
import { getBuilders, getGaLabel, getNewbuildingId } from '../../selectors/newbuilding';
import { setUserOpenedPhoneInNewobject } from '../../utils/lastHopePopup';
import { useApplicationContext } from '../../utils/withApplicationContext';

export const LastHopePopupCall = () => {
  const gaLabel = useSelector(getGaLabel);
  const builders = useSelector(getBuilders);
  const builderWithPhones = builders.find(builder => builder.phone && builder.phone.number);
  const newbuildingId = useSelector(getNewbuildingId);

  const onShowPhoneClick = React.useCallback(() => {
    trackShowPhone(gaLabel, 'Open_ask_builder_popup');
    setUserOpenedPhoneInNewobject(newbuildingId);
  }, [gaLabel, newbuildingId]);

  const { httpApi, logger } = useApplicationContext();

  const pageType = EPageTypes.NewbuildingCard;
  const platformType = EPlatformTypes.WebDesktop;
  const placeType = 'blockLastHopePopup';

  if (!builderWithPhones) {
    return null;
  }

  return (
    <SimpleCall
      builders={[builderWithPhones]}
      sellers={[]}
      onShowPhoneClick={onShowPhoneClick}
      openContactsStyles={{ size: 'XS' as const }}
      showPhoneStyles={{ size: 'XS' as const }}
      httpApi={httpApi}
      logger={logger}
      pageType={pageType}
      platformType={platformType}
      placeType={placeType}
    />
  );
};

LastHopePopupCall.displayName = 'LastHopePopupCall';
